function Privacy() {
    return (
        <div className="flex min-h-full px-4 pt-6 pb-24 md:px-10">
            <div className="container mx-auto md:pt-15">
                <article className="mx-auto prose max-w-4xl prose-darkgreen">
                    <p className="text-center text-sm font-medium tracking-[0.32em] text-neutral-400 uppercase">
                        LEGAL
                    </p>

                    <h1 className="mb-4 text-center text-6xl font-semibold tracking-wider">
                        Welnido Limited privacy notice (healthcare providers)
                    </h1>

                    <p className="lead mx-auto max-w-3xl text-center text-neutral-500">
                        This privacy notice tells you what to expect us to do
                        with your personal information.
                    </p>

                    <nav aria-label="Privacy notice contents">
                        <ul className="list-disc">
                            <li>
                                <a href="#contact-details">Contact details</a>
                            </li>
                            <li>
                                <a href="#information-collected">
                                    What information we collect, use, and why
                                </a>
                            </li>
                            <li>
                                <a href="#lawful-basis">
                                    Lawful bases and data protection rights
                                </a>
                            </li>
                            <li>
                                <a href="#information-source">
                                    Where we get personal information from
                                </a>
                            </li>
                            <li>
                                <a href="#retention">
                                    How long we keep information
                                </a>
                            </li>
                            <li>
                                <a href="#sharing">
                                    Who we share information with
                                </a>
                            </li>
                            <li>
                                <a href="#complaints">How to complain</a>
                            </li>
                        </ul>
                    </nav>

                    <h2 id="contact-details" className="text-2xl">
                        Contact details
                    </h2>

                    <p>
                        <strong>Post</strong>
                    </p>

                    <p>
                        Welnido Limited, The Grainger Suite, Dobson House,
                        Regent Centre, Gosforth, NEWCASTLE UPON TYNE, NE3 3PF,
                        GB
                    </p>

                    <p>
                        <strong>Email</strong>
                    </p>

                    <a href="mailto:dpo@welnido.com">dpo@welnido.com</a>

                    <h2 id="information-collected" className="text-2xl">
                        What information we collect, use, and why
                    </h2>

                    <p>
                        We collect or use the following personal information
                        <strong> to set-up and administer your account:</strong>
                    </p>

                    <ul className="list-disc">
                        <li>Names and contact details</li>
                        <li>Addresses</li>
                        <li>
                            Payment details including card or bank information
                            for transfers and direct debits)
                        </li>
                        <li>
                            Information in relation to qualifications,
                            registration and right to work in the United Kingdom
                            (as applicable)
                        </li>
                        <li>Indemnity insurance details</li>
                        <li>DBS Certificate details</li>
                        <li>
                            Proof of Identity (i.e. passport, driving licenses
                            or ID card)
                        </li>
                        <li>Marketing preferences</li>
                    </ul>

                    <p>
                        We collect or use the following personal information
                        <strong>
                            {" "}
                            for information updates, marketing or market
                            research purposes:
                        </strong>
                    </p>

                    <ul className="list-disc">
                        <li>Names and contact details</li>
                        <li>Addresses</li>
                        <li>Marketing preferences</li>
                    </ul>

                    <p>
                        We collect or use the following personal information
                        <strong>
                            {" "}
                            to facilitate and manage bookings, communicate
                            appointment details, process reviews and handle
                            payments:
                        </strong>
                    </p>

                    <ul className="list-disc">
                        <li>Name, address and contact details</li>
                        <li>
                            Payment details (including card or bank information
                            for transfers and direct debits)
                        </li>
                    </ul>

                    <h2 id="lawful-basis" className="text-2xl">
                        Lawful bases and data protection rights
                    </h2>

                    <p>
                        Under UK data protection law, we must have a "lawful
                        basis" for collecting and using your personal
                        information. There is a list of possible{" "}
                        <a href="https://ico.org.uk/for-organisations/advice-for-small-organisations/getting-started-with-gdpr/data-protection-principles-definitions-and-key-terms/#lawfulbasis">
                            lawful bases
                        </a>{" "}
                        in the UK GDPR. You can find out more about lawful bases
                        on the ICO's website.
                    </p>

                    <p>
                        Which lawful basis we rely on may affect your data
                        protection rights which are set out in brief below. You
                        can find out more about your data protection rights and
                        the exemptions which may apply on the ICO's website:
                    </p>

                    <ul className="list-disc">
                        <li>
                            <strong>Your right of access</strong> - You have the
                            right to ask us for copies of your personal
                            information. You can request other information such
                            as details about where we get personal information
                            from and who we share personal information with.
                            There are some exemptions which means you may not
                            receive all the information you ask for.{" "}
                            <a href="https://ico.org.uk/for-organisations/advice-for-small-organisations/privacy-notices-and-cookies/create-your-own-privacy-notice/your-data-protection-rights/#roa">
                                Read more about the right of access.
                            </a>
                        </li>
                        <li>
                            <strong>Your right to rectification</strong> - You
                            have the right to ask us to correct or delete
                            personal information you think is inaccurate or
                            incomplete.{" "}
                            <a href="https://ico.org.uk/for-organisations/advice-for-small-organisations/privacy-notices-and-cookies/create-your-own-privacy-notice/your-data-protection-rights/#rtr">
                                Read more about the right to rectification.
                            </a>
                        </li>
                        <li>
                            <strong>Your right to erasure</strong> - You have
                            the right to ask us to delete your personal
                            information.{" "}
                            <a href="https://ico.org.uk/for-organisations/advice-for-small-organisations/privacy-notices-and-cookies/create-your-own-privacy-notice/your-data-protection-rights/#rte">
                                Read more about the right to erasure.
                            </a>
                        </li>
                        <li>
                            <strong>
                                Your right to restriction of processing
                            </strong>{" "}
                            - You have the right to ask us to limit how we can
                            use your personal information.{" "}
                            <a href="https://ico.org.uk/for-organisations/advice-for-small-organisations/privacy-notices-and-cookies/create-your-own-privacy-notice/your-data-protection-rights/#rtrop">
                                Read more about the right to restriction of
                                processing.
                            </a>
                        </li>
                        <li>
                            <strong>Your right to object to processing</strong>{" "}
                            - You have the right to object to the processing of
                            your personal data.{" "}
                            <a href="https://ico.org.uk/for-organisations/advice-for-small-organisations/privacy-notices-and-cookies/create-your-own-privacy-notice/your-data-protection-rights/#rto">
                                Read more about the right to object to
                                processing.
                            </a>
                        </li>
                        <li>
                            <strong>Your right to data portability</strong> -
                            You have the right to ask that we transfer the
                            personal information you gave us to another
                            organisation, or to you.{" "}
                            <a href="https://ico.org.uk/for-organisations/advice-for-small-organisations/privacy-notices-and-cookies/create-your-own-privacy-notice/your-data-protection-rights/#rtdp">
                                Read more about the right to data portability.
                            </a>
                        </li>
                        <li>
                            <strong>Your right to withdraw consent</strong> -
                            When we use consent as our lawful basis you have the
                            right to withdraw your consent at any time.{" "}
                            <a href="https://ico.org.uk/for-organisations/advice-for-small-organisations/privacy-notices-and-cookies/create-your-own-privacy-notice/your-data-protection-rights/#rtwc">
                                Read more about the right to withdraw consent.
                            </a>
                        </li>
                    </ul>

                    <p>
                        If you make a request, we must respond to you without
                        undue delay and in any event within one month.
                    </p>

                    <p>
                        To make a data protection rights request, please contact
                        us using the contact details at the top of this privacy
                        notice.
                    </p>

                    <h3>
                        Our lawful bases for the collection and use of your data
                    </h3>

                    <p>
                        Our lawful bases for collecting or using personal
                        information{" "}
                        <strong> to set-up and administer your account</strong>{" "}
                        are:
                    </p>

                    <ul className="list-disc">
                        <li>
                            Consent - we have permission from you after we gave
                            you all the relevant information. All of your data
                            protection rights may apply, except the right to
                            object. To be clear, you do have the right to
                            withdraw your consent at any time.
                        </li>
                        <li>
                            Contract - we have to collect or use the information
                            so we can enter into or carry out a contract with
                            you. All of your data protection rights may apply
                            except the right to object.
                        </li>
                        <li>
                            Legal Obligations - to allow us to comply with any
                            requirements imposed on us by law or court order,
                            including disclosure to law or tax enforcement
                            agencies or authorities or pursuant to legal
                            proceedings.
                        </li>
                    </ul>

                    <p>
                        Our lawful bases for collecting or using personal
                        information{" "}
                        <strong>
                            for information updates, marketing or market
                            research purposes
                        </strong>{" "}
                        are:
                    </p>

                    <ul className="list-disc">
                        <li>
                            Consent - we have permission from you after we gave
                            you all the relevant information. All of your data
                            protection rights may apply, except the right to
                            object. To be clear, you do have the right to
                            withdraw your consent at any time.
                        </li>
                        <li>
                            Legal Obligations - to allow us to comply with any
                            requirements imposed on us by law or court order,
                            including disclosure to law or tax enforcement
                            agencies or authorities or pursuant to legal
                            proceedings.
                        </li>
                        <li>
                            Legitimate Interests - to send you information about
                            surveys and promotional offers.
                        </li>
                    </ul>

                    <p>
                        Our lawful bases for collecting or using personal
                        information{" "}
                        <strong>
                            to facilitate and manage bookings, communicate
                            appointment details, process reviews and handle
                            payments
                        </strong>{" "}
                        are:
                    </p>

                    <ul className="list-disc">
                        <li>
                            Consent - we have permission from you after we gave
                            you all the relevant information. All of your data
                            protection rights may apply, except the right to
                            object. To be clear, you do have the right to
                            withdraw your consent at any time.
                        </li>
                        <li>
                            Contract - we have to collect or use the information
                            so we can enter into or carry out a contract with
                            you. All of your data protection rights may apply
                            except the right to object.
                        </li>
                        <li>
                            Legal Obligations - to allow us to comply with any
                            requirements imposed on us by law or court order,
                            including disclosure to law or tax enforcement
                            agencies or authorities or pursuant to legal
                            proceedings.
                        </li>
                        <li>
                            Legitimate Interest - to collate and publish reviews
                            of services used on the platform, to keep our
                            records up to date and to resolve issues and improve
                            our services to you.
                        </li>
                    </ul>

                    <h2 id="information-source" className="text-2xl">
                        Where we get personal information from
                    </h2>

                    <ul className="list-disc">
                        <li>Directly from you</li>
                        <li>Publicly available sources</li>
                    </ul>

                    <h2 id="retention" className="text-2xl">
                        How long we keep information
                    </h2>

                    <p>
                        Unless a longer retention period is required or
                        permitted by law, we will only hold your personal
                        information on our systems for the period necessary to
                        fulfil the purposes outlined in this policy or until you
                        request that the information is deleted. Even if we
                        delete your personal information, it may persist on
                        backup or archival media for legal, tax or regulatory
                        purposes.
                    </p>

                    <h2 id="sharing" className="text-2xl">
                        Who we share information with
                    </h2>

                    <p>
                        Where required, we may share your personal data with
                        official bodies to fulfil our legal and regulatory
                        requirements.
                    </p>

                    <h2 id="complaints" className="text-2xl">
                        How to complain
                    </h2>

                    <p>
                        If you have any concerns about our use of your personal
                        data, you can make a complaint to us using the contact
                        details at the top of this privacy notice.
                    </p>

                    <p>
                        If you remain unhappy with how we've used your data
                        after raising a complaint with us, you can also complain
                        to the ICO.
                    </p>

                    <p>The ICO's address:</p>

                    <p>
                        Information Commissioner's Office
                        <br />
                        Wycliffe House
                        <br />
                        Water Lane
                        <br />
                        Wilmslow
                        <br />
                        Cheshire
                        <br />
                        SK9 5AF
                    </p>

                    <p>
                        Helpline number:{" "}
                        <a href="tel:03031231113">0303 123 1113</a>
                    </p>

                    <p>
                        Website:{" "}
                        <a href="https://www.ico.org.uk/make-a-complaint">
                            https://www.ico.org.uk/make-a-complaint
                        </a>
                    </p>
                </article>
            </div>
        </div>
    );
}

export default Privacy;
